import { supabase } from './supabase';
import { ErrorDeApi } from './error-api';

interface MisDatos {
  nombres: string;
  apellidos: string;
  telefono?: string;
  documentoTipo?: string;
  documentoNumero?: string;
}

/**
 * Los datos de la persona viven en la membresía, así que esto cambia quién es *en ese negocio*.
 * Devuelve el nombre visible que quedó, ya normalizado por el servidor, que es el que manda: el
 * celular y el documento se validan otra vez allá con las funciones que usan los terceros.
 */
export async function actualizarMisDatos(negocioId: string, d: MisDatos): Promise<string> {
  const { data, error, status } = await supabase.rpc('actualizar_mi_nombre', {
    p_negocio: negocioId,
    p_nombres: d.nombres,
    p_apellidos: d.apellidos,
    p_telefono: d.telefono || null,
    p_documento_tipo: d.documentoTipo || null,
    p_documento_numero: d.documentoNumero || null,
  });
  if (error) throw new ErrorDeApi(error, status);
  return data as string;
}

interface DatosPanel {
  nombre: string;
  apellido?: string;
  telefono?: string;
  cargo?: string;
}

/** Los datos con que el equipo que opera el panel se identifica entre sí. */
export async function actualizarMiPerfilPanel(d: DatosPanel): Promise<DatosPanel> {
  const { data, error, status } = await supabase.rpc('actualizar_mi_perfil_plataforma', {
    p_nombre: d.nombre,
    p_apellido: d.apellido || null,
    p_telefono: d.telefono || null,
    p_cargo: d.cargo || null,
  });
  if (error) throw new ErrorDeApi(error, status);
  return data as DatosPanel;
}

/**
 * Pide el cambio de correo. Con la confirmación en las dos direcciones activada llegan dos códigos,
 * uno a la actual y otro a la nueva, y hay que confirmar ambos.
 */
export async function pedirCambioDeCorreo(correoNuevo: string): Promise<void> {
  // `AuthError` ya extiende Error y su mensaje llega a la pantalla: no hay que envolverlo.
  const { error } = await supabase.auth.updateUser({ email: correoNuevo.trim().toLowerCase() });
  if (error) throw error;
}

/** Confirma uno de los dos códigos del cambio de correo. */
export async function confirmarCambioDeCorreo(correo: string, codigo: string): Promise<void> {
  const { error } = await supabase.auth.verifyOtp({
    email: correo.trim().toLowerCase(),
    token: codigo.trim(),
    type: 'email_change',
  });
  if (error) throw error;
}
